import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import img1 from "../assets/images/Carousel/1.jpg";
import img2 from "../assets/images/Carousel/2.jpg";
import img3 from "../assets/images/Carousel/3.jpg";
import img4 from "../assets/images/Carousel/4.jpg";
import "./index.css"; // Import CSS

export default function HeroSectionCarousel() {
  return (
    <Carousel
      additionalTransfrom={0}
      arrows
      autoPlay={true}
      autoPlaySpeed={3000}
      centerMode={false}
      className="carousel-container"
      containerClass="carousel-container"
      dotListClass=""
      draggable
      focusOnSelect={false}
      infinite
      itemClass=""
      keyBoardControl
      minimumTouchDrag={80}
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
      }}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots
      sliderClass=""
      slidesToSlide={1}
      swipeable
    >
      {[
        {
          img: img1,
          title: "THE ORBIT SECURITIES PRIVATE LIMITED",
          description:
            "Orbit Securities Private Limited is one of the emerging brokerage house in Pakistan. Orbit Securities Limited was incorporated as a Private Limited Company under the Companies Ordinance, 1984. Limited takes pride in its ability to deliver innovative financial solutions to a growing client base currently comprising of domestic and international clients. We have assembled a core team of expert professionals with a high level of integrity, financial acumen and industry experience.",
        },
        {
          img: img2,
          title: "TO US SUCCESS IS NOT A DESTINATION",
          description:
            "Orbit Securities Pvt. Limited is not only a name or a company. It is a passion, a desire to grow, serve and excel. For our clients Orbit Securities Pvt. Limited is a name which stands for its commitment, customer care, integrity, market knowledge & trouble-free services. All this have been achievable with the grace of Almighty Allah, prayers of our parents and untiring hard work of our team members. “TO US SUCCESS IS NOT A DESTINATION, IT IS A JOURNEY AND WE ARE FOCUSED ON IT”.",
        },
        {
          img: img3,
          title: "We Believe That Client Satisfaction",
          description:
            "Our activities are geared towards helping out investors to enhance their portfolio performance and to take part in the future growth of the Capital Market. All of the team members are thankful to their clients for their complete faith on Orbit Securities Pvt. Limited. Our mission is to develop an everlasting as well as blossoming relationship with our clients. Orbit Securities Pvt. Limited ensures that its customized services offerings facilitate not only current but also future Capital market requirements of its clients we strongly believe that only by offering a wide range of Services of good quality and by exquisite customer care we will be in a mutually beneficial bonding with our clients leading all stake holders to success.",
        },
        {
          img: img4,
          title: "Our Successful Investment Ideas",
          description:
            "we have over time evolved into a top-notch brokerage house anticipating and satisfying customer needs through synchronized team effort and utmost professionalism. Our efforts are to be client focused, service driven and growth oriented, endeavoring for excellence as a best brokerage house and provider of premier investment services through excellence in organizational, personal character, integrity thus making meaningful contributions to our Capital Market.",
        },
      ].map((slide, index) => (
          <img
            src={slide.img}
            className="carousel-image"
            alt={`Slide ${index + 1}`}
          />
      ))}
    </Carousel>
  );
}
